<app-loader *ngIf="isDisabled"></app-loader>
<form name="LetterTemplateForm" (ngSubmit)="Validate(LetterTemplateForm)" #LetterTemplateForm="ngForm">
    <div class="card">
        <div class="card-header">
            <label>Letter Template</label>
        </div>
        <div class="card-body">
            <div class="row py-1">
                <div class="col-md-12">
                    <label for="LetterCode">Letter Code <span *ngIf="ID > 0"> : {{LetterTemplateDetail.LetterCode}}
                        </span> </label>
                    <input *ngIf="ID == 0" type="text" [maxLength]="20" class="form-control" name="LetterCode"
                        placeholder="Code" [(ngModel)]="LetterTemplateDetail.LetterCode" #LetterCode="ngModel"
                        (input)="common.ToUpperCaseE($event)" pattern="[a-zA-Z ]*"
                        (keypress)="common.AlphabetOnly($event,true)" required>
                    <div class="invalid-feedback">
                        Please enter letter code!
                    </div>
                </div>
            </div>
            <div class="row py-1">
                <div class="col-md-12">
                    <label for="LetterName">Letter Name</label>
                    <input type="text" [maxLength]="50" class="form-control" name="LetterName" placeholder="Name"
                        [(ngModel)]="LetterTemplateDetail.LetterName" #LetterCode="ngModel" required>
                    <div class="invalid-feedback">
                        Please enter letter name!
                    </div>
                </div>
            </div>
            <div class="row py-1">
                <div class="col-md-12">
                    <label for="ESS_LetterDocumentTypeMasterID">Document Type</label>
                    <ng-select name="ESS_LetterDocumentTypeMasterID" id="ESS_LetterDocumentTypeMasterID"
                        [items]="LetterTypes" bindLabel="LetterDocumentTypeName"
                        bindValue="ESS_LetterDocumentTypeMasterID"
                        [(ngModel)]="LetterTemplateDetail.ESS_LetterDocumentTypeMasterID"
                        #ESS_LetterDocumentTypeMasterID="ngModel" placeholder="Document Type" required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select document type!
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="LetterTemplateDetail.Active"
                            [name]="'Active'" id="LetterTemplateDetail">
                        <label class="form-check-label" for="LetterTemplateDetail">
                            Active
                        </label>
                    </div>
                </div>
                <div class="col-auto">
                    <button type="button" class="btn btn-outline-primary me-1" (click)="close()" [disabled]="isDisabled"
                        ngbTooltip="Cancel" container="body" placement="top">
                        Cancel
                        <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                    </button>

                    <button type="submit" class="btn btn-primary" [disabled]="isDisabled"
                        *ngIf="((this.LetterTemplateDetail.ESS_LetterTemplateMasterID == 0 && this.common.PageRight.IsAdd) || (this.LetterTemplateDetail.ESS_LetterTemplateMasterID > 0 && this.common.PageRight.IsEdit))"><i
                            class="bi bi-save2" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Save':'Loading...'}}</button>
                </div>
            </div>
        </div>
    </div>
</form>